// extracted by mini-css-extract-plugin
export default {"root":"workforce_member_column-module___root___d049574f"};